interface VolumeIconProps {
    className?: string;
}

export function VolumeIcon( { className }: VolumeIconProps ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            <path
                d="M9 6H11V20H9V6ZM13 8H15V20H13V8ZM17 4H19V20H17V4ZM5 12H7V20H5V12Z"
                fill="var(--ui-content-t1)"
            />
        </svg>
    );
}
